export default __webpack_public_path__ + "static/media/prize-2-cn.a56d6e53.webp";